export default {
    login: 'Anmeldung',
    logout: 'Abmeldung',
    register: 'Registrierung',
    upload: 'Hochladen',
    name: 'Name',
    email: 'Email',
    password: 'Passwort',
    passwordConfirmation: 'Passwort bestätigen',
    isCommunityManager: 'Community Manager',
    dashboard: 'Dashboard',
    offerLists: 'Angebotsliste',
    schedule: 'Zeitplan',
    accountEdit: 'Kundenkonto bearbeiten',
    edit: 'Bearbeiten',
    detail: 'Details',
    fullname: '{{lastname}} {{firstname}}',
    quantity: 'Anzahl',
    quantityWithWeight: 'Anzahl (Gewicht)',
    confirmTitle: 'Bestätigen',
    orderInformation: 'Information zur Reservierung',
    orderPrices: 'Liste der Preisänderungen',
    invoices: 'Rechnungen',
    contact: 'Kontakt',
    when: 'Wann',
    add_to_google_calendar: 'Zu Google Kalender hinzufügen',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: 'CSV hochladen',
            producer: 'Producer',
            download: 'Herunterladen der CSV Vorlage',
            sampleDeliveryDateMemo: 'Es muss mindestens 14 Tage vor dem Wunschdatum der Veröffentlichung des Angebotes liegen',
            uploadMemo: 'Wenn das Hochladen abgeschlossen ist, wird sich ein Zuständiger in den nächsten Tagen bei Ihnen melden',
            suggestToCreateBankAccountText: "Sie m\u00FCssen ein Bankkonto angeben, um Einnahmen zu erhalten.\nIhre Kontoinformationen sind erforderlich, wenn ein Sales Contract ausgestellt wird, daher wird empfohlen, dass Sie Ihre Daten zum Zeitpunkt des Hochladens der Angebotsliste registrieren.",
        },
        offerList: {
            title: 'Angebotsliste für {{ country }} / {{ name }}',
            createInvoices: 'Rechnungen erstellen',
            createInvoicesExplanation: "Rechnungen werden pauschal f\u00FCr diejenigen ausgestellt, deren Zahlungskondition \"1. Einmalige Zahlung nach Wunsch des Herstellers\" entspricht.\nF\u00FCr Reservierungen, f\u00FCr die bereits eine Rechnung ausgestellt wurde, wird jedoch keine neue Rechnung erstellt.\nDie URL der erstellten Rechnung wird jedem R\u00F6ster per Email zugesandt.",
            sampleOrderStock: {
                quantity: 'Aufteilung des Warenprobelagerbestands',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: 'Verkaufsland',
            basicInformations: 'Grundinformationen',
            publishedCountriesTable: 'Verkaufsland',
            transportToWarehouseTable: 'Transportinformationen zum einzelnen Lager',
            officeDetailTable: 'Office Information',
            offersTable: 'Offers',
            contracts: 'Contracts',
            sampleOrderPeriod: 'Warenprobeanfrage',
            orderPeriod: 'Bestellanfrage',
            paymentPeriod: 'Möglicher Zahlungszeitpunkt',
            estimatedDeliveryPeriod: 'Vorraussichtlicher Liefertermin',
            paymentAfterDelivery: 'Bezahlung auf Rechnung',
            paymentPeriods: {
                reserved: 'On order confirmation',
                exported: 'On departure from origin',
                imported: 'On arrival at destination',
                delivered: 'On delivery',
            },
            installmentPaymentAfterImport: 'Raten nach Eingang in das Lager',
            installmentPayment: 'ratenzahlung',
            estimatedPaymentDateFormat: '{{date}} {{month}} {{year}}',
            installmentPaymentsHelp: {
                title: 'Zahlen auf Rechnung',
                body: "Wenn Sie bei der Reservierung \"auf Rechnung\u201C ausw\u00E4hlen, k\u00F6nnen Sie bezahlen, erst nachdem die Ware zugestellt worden ist.\nSie k\u00F6nnen ausw\u00E4hlen, entweder, nach der ersten Warenzustellung \"den gesamten Betrag auf Rechnung zu zahlen\u201C oder, \"zu jeder Zustellung auf Rechnung zu bezahlen\u201C.",
            },
            FreeOnBoardHelp: {
                title: 'Was bedeutet FOB?',
                body: "Der Preis enth\u00E4lt nur die Kosten f\u00FCr die Rohkaffeebohnen und den Transport bis zum Hafen des Ursprungslandes.\nSeefracht und Einfuhrgeb\u00FChren sind nicht im Preis enthalten.",
            },
            estimatedDeliveryPeriodFormat: '{{monthPart}} {{month}} {{year}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: 'Profil bearbeiten',
            subTitle: 'Kundeninformation',
            questionnairesForRoaster: 'Fragebogen für Röster',
            questionnairesForRoasterMemo: '* Folgende Informationen können später noch geändert werden',
            cannotChangeCountry: '* Bitte beachten Sie, dass Sie das Land nicht mehr ändern können, wenn Sie es einmal eingetragen haben.',
        },
        editAccount: {
            title: 'Kundenkonto bearbeiten',
            currentEmail: 'Aktuelle Email-Adresse',
            warning: "Nach der \u00C4nderung der Email-Adresse werden Sie einmal ausgeloggt.\nEs wird eine Best\u00E4tigungsmail an Ihre neue Adresse gesendet, die einen Link enth\u00E4lt.\nWenn Sie auf diesen Link anklicken, so wird die \u00C4nderung abgeschlossen.\nDanach k\u00F6nnen Sie sich mit der neuen Adresse anmelden.",
        },
        exchangeRates: {
            title: 'Einstellungen des Wechselkurses',
            exchangeRateColumnTitle: 'Umrechnung für USD/{{ currency }}',
        },
        roasterOfferLists: {
            sampleRequest: 'Warenprobeanfrage',
            order: 'Reservierung',
            inactive: 'Veröffentlichung beendet',
        },
        roasterOrder: {
            title: 'Reservierung von {{ listName }}',
            explanationSelectOffers: '・Prüfen Sie die Anzahl des Lagerbestands in der untenstehenden Liste und wählen Sie dann die korrekte Stückzahl für die Reservierung.',
            explanationAuctionWithFobPriceUsdPerLb: '* Auktionsergebnisse in USD/Kg(1kg=2.20462lb)',
            explanationStockMightChange: '* Denken Sie daran, dass sich der Lagerbestand reduzieren kann, während Sie dieses Fenster geöffnet haben.',
            order: 'Reservierung',
            orderAmount: 'Reservierung',
            totalFee: 'Gesamtkosten: {{ fee }} (vor Steuer)',
            totalBags: 'Gesamtanzahl der Packungen: {{ amount }}',
            totalOrderedBags: 'Anzahl (gesamt): {{ amount }} Packungen',
            totalWeight: 'Gesamtgewicht: {{ weight }}kg',
            totalOrderedWeight: 'Bestelltes Gewicht: {{ weight }}kg',
            totalOneTimeUpfrontOrderedBags: 'Anzahl (vorausbezahlt): {{ amount }} Packungen',
            typicaHandlingFee: 'TYPICA-Gebühren: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: 'Weniger als 5 Packungen {{ lessThan5Bags }} / ab 5 Packungen {{ moreThan5Bags }} / ab 10 Packungen {{ moreThan10Bags }} / ab 50 Packungen {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: 'Unter 300kg: {{ lessThan300Kg }} / Ab 300kg: {{ moreThan300Kg }} / Ab 600kg: {{ moreThan600Kg }} / Ab 3,000kg: {{ moreThan3000Kg }}',
            details: 'Details',
            paymentAndDelivery: 'Zahlungsmethode / Lieferadresse',
            paymentMethodExplanation: "* Kreditkartenlimits und Voraussetzungen f\u00FCr die Ratenzahlung unterscheiden sich je nach Benutzer. Bitte wenden Sie sich f\u00FCr Einzelheiten an Ihr Kreditkartenunternehmen.\n        * Bitte beachten Sie, dass es bei einem 8-stelligen Rechnungsbetrag vorkommen kann, dass als Zahlungsoption ausschlie\u00DFlich Bank\u00FCberweisung m\u00F6glich ist.",
            endOfMonth: 'Bis Ende',
            oneTimeUpfrontExplanations: '- Zahlungsfrist ist {{ paymentDate }}. Einzelheiten entnehmen Sie bitte der Rechnung, die nach Ablauf des Angebots ausgestellt wird.',
            afterImportPaymentExplanations: "- Die Zahlung ist innerhalb von 14 Tagen nach Eingang des Kaffees im Lager (Voraussichtlicher Termin: {{ deliveryPeriod }}) f\u00E4llig.\n      - Die Ware kann nach erfolgter Bezahlung geliefert werden.",
            fewTimesPaymentAfterImportExplanations: "- Die erste Zahlung ist innerhalb von 14 Tagen nach Eingang des Kaffees im Lager (Voraussichtlicher Termin: {{ deliveryPeriod }}) f\u00E4llig.\n      - Die Ware kann erst nach Abschluss der ersten Zahlung geliefert werden.\n      - Die zweite und die folgenden Zahlungen sind am Ende des Monats nach der Lagerbuchung f\u00E4llig. Einzelheiten finden Sie in der zu Beginn des Monats ausgestellten Rechnung.",
            paymentTimingExplanation: '* Die Gebühren unterscheiden sich je nach Zahlungszeitpunkt. Einzelheiten entnehmen Sie bitte dem Preissimulator am unteren Rand des Bildschirms.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (bei Reservierungen ab 2 oder mehr Packungen)',
            oneTimeUpfrontRateConstraintByWeight: ' (Nur für Reservierungen ab 120kg)',
            deliveryMethodExplanation: "* Eine monatliche Lagergeb\u00FChr von {{unitPrice}} pro kg wird ab dem ersten Tag des zweiten Monats nach dem Datum des Eingangs in unser Lager berechnet.",
            oneTimeUpfrontRateByBagAmount: '(Rabatt von {{ percentage }} gewährt * bei Reservierungen ab 2 oder mehr Packungen)',
            oneTimeUpfrontRateByWeight: ' | Rabatt von -{{ percentage }}',
            paymentTimingNegativeRate: ' | Rabatt -{{ percentage }}',
            paymentTimingPositiveRate: ' | {{ positive }}{{ percentage }} Extragebühren',
            addressExplanation: '* Bitte geben Sie Hausnummer und gegebenenfalls eine Zimmernummer an.',
            emailExplanation: '* Bitte achten Sie darauf, ihre Email-Adresse korrekt einzugeben.',
            deliveryTimeEtcExplanation: '* Es ist mitunter nicht möglich, den gewünschten Liefertermin etc. einzuhalten. Wir bitten um Ihr Verständnis.',
            sample: 'Warenprobe',
            sampleOrder: 'Warenprobeanfrage',
            sampleOrdered: 'Reserviert',
            outOfSamples: 'Out of samples',
            bidSubmitted: 'Gebot abgegeben',
            sampleOrderableCount: 'Mögliche Losgröße für Warenprobeanfrage',
            inputAddress: 'Adresse eingeben',
            simulateAndInputAddress: 'Kostendetails und Adresse eingeben',
            simulation: 'Preissimulation',
            sampleOrderCaption: 'Folgende Los-Warenproben werden reserviert',
            comment: 'Kommentar',
            commentHelp: '* Kommentare werden mit dem Hersteller und anderen Röstern geteilt',
            translation: '* Kommentare können ins Englische, Spanische, Japanische, Chinesische und Koreanische übersetzt werden.',
            postComment: 'Kommentar hinzufügen',
            updateComment: 'Kommentar bearbeiten',
            deleteComment: 'Kommentar löschen',
            noComments: 'Keine Kommentare',
            cuppingScoreHelpText: 'Bitte tragen Sie Ihre Bewertungspunktzahl in das SCA-Cupping-Formular ein',
            more: 'Weitere Informationen',
            ordered: 'Reservierung abgeschlossen',
            addInvoice: 'Rechnung erstellen',
            preOrderExplanation: 'Die Zeitspanne der Bestellung ist voraussichtlich von {{startedAt}} bis {{endedAt}}.',
            countdownToOrder: 'Verbleibende Zeit bis zur Vorbestellung: {{countdown}}',
            confirmationOfBuyPartial: 'Gebot ist nicht erfolgreich, wenn das Los {{lotNumber}} kleiner ist als die Gebotsmenge',
            auctionBadgeExplanation: "Dieses Los wird in einer Blindauktion versteigert.\nBitte geben Sie den gew\u00FCnschten Einkaufspreis und die Menge ein.\nDer Betrag, der \u00FCber dem Startpreis liegt, wird dem Hersteller als Auktionsbonus ausgezahlt.\nDas Ergebnis der Auktion wird zu einem sp\u00E4teren Zeitpunkt per E-Mail mitgeteilt.\nDie Zahl auf dem Abzeichen ist die aktuelle Anzahl der gew\u00FCnschten K\u00E4ufe.",
            okagesamaNoMoriPrice: '* Teilnahmekosten {{ priceUsd }} (ca. {{ price }})',
            okagesamaNoMoriPriceText: '(Die Kosten für die Teilnahme können je nach Wechselkurs variieren.)',
            sampleStats: 'von Röstern angesehen',
            preorderStats: 'von Röstern gekauft',
        },
        ordersPage: {
            title: 'Alle Reservierungen',
            detailsTitle: 'Pre-orders details',
        },
        sampleOrdersPage: {
            title: 'Alle Warenprobeanfragen',
        },
        register: {
            accept: 'Bedingungen zustimmen',
        },
        orderedOfferLists: {
            title: 'Reservierte Angebotsliste',
        },
        sampleOrders: {
            title: 'Alle Warenprobeanfragen',
            import: 'Import der Probenanforderungen',
        },
        sampleOrderedOfferLists: {
            title: 'Angebotsliste der Warenprobeanfragen',
        },
        orderDetail: {
            orderItemsTableTitle: 'Alle Los-Reservierungen',
            bidsTableTitle: 'Alle Los-Gebote',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: 'Anfrage erstellen oder bearbeiten',
        },
        sampleOrderDetail: {
            requestedLotNumbers: 'Warenprobeanfrage Lot#',
        },
        invoice: {
            title: 'Rechnung der Reservierung {{orderIds}}',
            billingTo: 'Rechnungsempfänger',
            billingAddress: 'Rechnungsadresse',
            transparencyInformation: {
                farm: 'Hersteller',
                farmExplanation: 'Informationen über den Hersteller finden Sie <1>hier</1>.',
                mill: 'Aufbereitungsfabrik',
                millExplanation: 'Die Kaffeekirschen und Pergamenthaut etc., die von Kleinproduzenten gekauft werden, werden In der regionalen Fabrik aufbereitet. Transportkosten und Zollgebühren innerhalb des Produktionslandes sind inbegriffen.',
                auctionBonus: 'Auktionsbonus',
                auctionBonusExplanation: 'Betrag, um welchen der Kaufpreis in der Blindauktion den Startpreis übersteigt. Dieser Betrag wird dem Hersteller als Auktionsbonus ausgezahlt.',
                shippingFee: 'Versandkosten',
                shippingFeeExplanation: 'Die Summe von Transportkosten und Importkosten (Zollabfertigungskosten, Anmeldegebühren für Pflanzenquarantäne etc.)',
                importTax: 'Importsteuer',
                importTaxExplanation: '{{ importTaxRate }} auf die Summe von Transportkosten und Warenpreis.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'TYPICA-Honorar. ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: 'TYPICA-Servicegebühr. (Weniger als 5 Packungen {{ lessThan5Bags }} / ab 5 Packungen {{ moreThan5Bags }} / ab 10 Packungen {{ moreThan10Bags }} / ab 50 Packungen {{ moreThan50Bags }})',
                typicaExplanationByWeight: 'TYPICA-Honorar. (Unter 300kg: {{ lessThan300Kg }}, Ab 300kg: {{ moreThan300Kg }}, Ab 600kg: {{ moreThan600Kg }}, Ab 3,000kg: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'TYPICA-Honorar. (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'TYPICA-Honorar. (Unter 300kg: 40%, Ab 300kg: 35%, Ab 600kg: 30%, Ab 3,000kg: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'TYPICA-Honorar. (Unter 300kg: 35%, Ab 300kg: 25%, Ab 600kg: 20%, Ab 3,000kg: 15%)',
                consumptionTaxExplanation: '{{ taxRate }} der steuerpflichtigen Kosten und Gebühren.',
                vatReverseChargeExplanation: 'Umkehrung der Steuerschuldnerschaft (0%) ist inbegriffen.',
                oldPriceVersionKgPriceNotice: 'Es handelt sich um den Kilopreis ohne "Gebühren für Kreditzahlung (steuerfrei), Vorkasse Rabatt" und "Servicegebühr (steuerfrei)".',
                newPriceVersionKgPriceNotice: 'Kilo-Einheitspreis ohne "Zahlungszeitpunkt-abhängige Gebühren und Rabatte".',
                specialTypicaDiscount: 'Discount',
                specialTypicaDiscountExplanation: 'This is the total discount amount.',
                shippingFeeForJp: 'Kosten für Überseetransporte',
                shippingFeeExplanationForJp: 'Die Kosten vom Ladehafen bis zum Hafen/Flughafen der Anlandung.',
                importTaxForJp: 'Einfuhr- und Transportkosten',
                importTaxExplanationForJp: 'Gesamtkosten für Transport und Einfuhr (Zollabfertigungsgebühren, Gebühren für Pflanzenschutzanträge usw.) vom Anlandehafen bis zum Lagerhaus.',
                consumptionTaxExplanationForJp: 'Die Gesamtsteuerbemessungsgrundlage beträgt 8 % für Rohkaffeebohnen und 10 % für Überseetransporte und andere Kosten.',
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: 'Zahlungsstatus',
            paidMessage: 'Bezahlung abgeschlossen am {{paidDate}}',
            unpaidMessage: 'Bezahlung muss bis zum {{expiredDate}} erfolgen',
            changePaymentMethod: 'Zahlungsmethode ändern',
            vatrcHelp: 'Geben Sie Ihre Umsatzsteuer-Identifikationsnummer in Ihrem Profil an, damit die Umkehrung der Steuerschuldnerschaft erhoben wird.',
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: 'Alle Röster',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: 'Alle Hersteller',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: 'Informationen zum Produktionsland',
        },
        roasterCountries: {
            title: 'Verkaufsländer',
        },
        adminOrder: {
            title: 'Reservierung als Stellvertreter',
            selectRoaster: 'Wählen Sie einen Röster aus',
        },
        warehouses: {
            title: 'Lagerverwaltung',
        },
        warehouseItems: {
            title: 'Lagerbestand',
            deliveryRequest: 'Lieferanfrage',
            addressInfo: 'Lieferadresse',
            selectItems: 'Wählen Sie das Lot, dessen Lieferung Sie anfordern möchten',
            explainationForQuantity: 'Da die Menge die Packungsanzahl zeigt, kann sie anders sein als die Anzahl bei der Reservierung',
            editDeliveryRequest: {
                caption: 'Soll Ihr Lieferplan geändert werden?',
                button: 'Lieferplan bearbeiten',
            },
        },
        deliveryRequests: {
            title: 'Alle Lieferanfragen',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: 'Details der Lieferanfragen',
            basicInfo: 'Grundlegende Informationen',
            editForm: 'Bearbeitungsformular',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: 'Lieferung möglich',
            delivered: 'Lieferung zugestellt',
            delivering: 'In Auslieferung',
        },
        offerListForum: {
            translateMessage: 'Nachricht übersetzen',
            changeTranslationLanguage: 'Übersetzungssprache ändern',
            languages: {
                en: 'Englisch',
                es: 'Spanisch',
                ja: 'Japanisch',
                zh: 'Chinesisch',
                ko: 'Koreanisch',
            },
        },
        monthlyClosing: {
            title: 'Alle Monatsabschlüsse',
            createButton: 'Monatsabschluss erledigen',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: 'Niederlassung',
        },
        invoicePayment: {
            title: 'Bezahlung der Rechnung "{{invoiceTitle}}"',
            suspendedMessage: "Es tut uns sehr leid.\n\nKreditkartenzahlungen sind derzeit wegen der Umstellung des Zahlungssystems vor\u00FCbergehend ausgesetzt. Bitte haben Sie ein wenig Geduld, bis der Umstellungssprozess abgeschlossen ist.\nBitte t\u00E4tigen Sie Ihre Zahlung, nachdem die Umstellung des Zahlungssystems abgeschlossen ist, oder wenn Sie es eilig haben, \u00FCberweisen Sie bitte per Bank\u00FCberweisung.\n",
        },
        transportToWarehouse: {
            waterActivity: 'Wasseraktivität',
            moistureContent: 'Wassergehalt',
        },
        adminAuction: {
            title: 'Auktionsstatus von {{offerListName}} / {{lotNumber}}',
            auctionClosed: 'Diese Auktion ist bereits beendet',
            auctionOpened: 'Diese Auktion ist offen',
            closeAuction: 'Auktion beenden',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: 'Alle Gebote',
        },
        roasterAuction: {
            title: 'Auktionsergebnis von {{offerListName}} / {{lotNumber}}',
            bidQuantity: 'Anzahl erfolgreicher Gebote',
            roasterAuctionResult: 'Ihre erfolgreichen Gebote',
            auctionResult: 'Alle Ergebnisse',
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: 'Liste der Bankkonten',
            edit: 'Bankkonto bearbeiten',
            new: 'Bankkonto hinzufügen',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'TYPICA Sortiment',
            order: 'Reservierungsdetails anzeigen',
            sampleOrderPeriod: 'jederzeit',
            orderPeriod: 'jederzeit',
            paymentPeriod: 'Bezahlung auf Rechnung',
            estimatedDeliveryPeriod: 'ca.1 Woche nach Reservierung',
            sampleOrder: 'Klicken Sie hier, um eine Probe anzufordern.',
            orderFormStepper: {
                order: 'Zahlungs- und Rechnungsadresse',
                deliveryRequest: 'Lieferauftrag',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: 'Das Wunschlieferdatum ist leer',
                        body2: 'Bitte geben Sie das gewünschte Lieferdatum an',
                    },
                    installment: {
                        body1: 'Es sind noch Lose für Lieferanfragen verfügbar',
                        body2: 'Geben Sie die Lieferzeiten für alle Teillieferungen an',
                    },
                },
                isNotWarehousing: {
                    body1: 'Noch nicht vorrätig',
                    body2: 'Liefertermine können nicht angegeben werden, es sei denn, es handelt sich um Lose, die vorrätig sind',
                },
                inValidDeliveryRequestItemsAndRequestDate: 'Bitte geben Sie die Anzahl der Lieferungen oder ein bestimmtes Lieferdatum ein',
            },
        },
        preOrderRequest: {
            title: 'Liste erneuter Bestellungen',
            new: 'Erneute Bestellung erstellen',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: 'Anfrage aus derselben Angebotsliste',
        },
        roasterAddresses: {
            title: 'Adressbuch verwalten',
            billingAddresses: 'Rechnungsadresse',
            deliveryAddresses: 'Lieferadresse',
        },
        cuppingComments: {
            title: 'Cupping-Zusammenfassung',
            commentedBy: 'Beigetragen von',
            otherRoasters: 'Andere {{ count }} Röster anzeigen',
        },
        createCuppingComment: {
            title: 'Kommentieren',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: 'Lieferauftrag',
            subheaders: {
                oneTime: 'Wir liefern in einer Komplettlieferung zum voraussichtlichen Lieferzeitpunkt.',
                installment: 'Wir teilen ab der voraussichtlichen Lieferzeit in bis zu drei Teillieferungen.',
                installmentCaption: 'Voraussichtliche Lieferung: etwa 1 Woche nach Reservierung',
            },
            type: {
                oneTime: 'Komplettlieferung',
                installment: 'Teillieferung',
            },
            changeTimings: 'Änderung zu {{ timing }}',
            buttons: {
                new: 'Lieferzeit festlegen',
                add: 'Lieferzeit hinzufügen',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* Wenn Sie keine Angaben machen, erfolgt die Zustellung in der kürzest möglichen Zeit.',
                    main: {
                        deliveryDateExplanation: '* Sie können einen Zeitraum ab dem Datum {{ startWeek }} nach heute bis zu 5 Monaten ab dem Datum des Lieferauftrags angeben.',
                        startWeek1: '1 Woche',
                        startWeek2: '2 Wochen',
                    },
                    sub: {
                        europe: '* Wir empfehlen, ein frühes Lieferdatum anzugeben, da sich die tatsächliche Lieferung in einigen Gebieten um durchschnittlich zwei Wochen verzögern kann. Bitte haben Sie dafür im Voraus Verständnis.',
                        etc: '* Wir empfehlen, ein frühes Lieferdatum anzugeben, da sich die tatsächliche Lieferung in einigen Gebieten um bis zu einer Woche verzögern kann. Bitte haben Sie dafür im Voraus Verständnis.',
                    },
                },
                card: '* Wir empfehlen eine Komplettlieferung, um die Frische zu gewährleisten. Je nach Wunsch können Sie auch eine Teillieferung auswählen.',
            },
            dialog: {
                title: 'Lieferzeit',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
    },
    labels: {
        stock: 'Verfügbar',
        stockUnit: 'Packungen',
        lotRef: 'LOT',
        offerListSummary: 'Angebotsübersicht',
        farmWithLink: 'Plantage',
        curatorName: 'Verwalter',
        seller: 'Anbieter',
        material: 'Materialien',
        story: 'Erzählung',
        period: 'Angebotszeitraum',
        activeOfferLists: 'Veröffentlicht',
        preparingOfferLists: 'In Bearbeitung',
        expiredOfferLists: 'Beendet',
        noData: 'Keine Daten vorhanden',
        paymentTimingOnAdmin: 'Zahlungszeitpunkt',
        fullAddress: 'Adresse',
        deliveryItems: 'Lieferungsliste (Lot: Anzahl)',
        all: 'Alle',
        inStock: 'Vorrätig',
        forum: 'Forum',
        forumDisplayName: 'Benutzername im Forum',
        taxed: 'steuerpflichtig',
        paymentTimingHandlingFee: {
            negativeValue: 'Rabatt',
            positiveValue: 'Extragebühren',
        },
        paid: 'Bezahlt',
        exported: 'Beim Export',
        imported: 'Beim Import',
        uploadContract: 'Bitte den hochzuladenden Vertrag auswählen',
        uploadDocuments: 'Dokument auswählen',
        uploadBusinessNumberKrdocument: 'Bitte wählen Sie eine Bilddatei aus',
        selectFoundingCurator: 'Input Founding curator name',
        pending: 'Pending',
        newRoasterCampaignDiscount: 'Rabatt auf Ihre erste Bestellung',
        couponTarget: 'Gutschein eingelöst',
        newRoasterCampaignUnderway: 'Promo for first-time users!',
        agree: 'Agree',
        memo: 'Anmerkungen',
        tradeCountryUsages: 'Verwendung',
        tradeCountryProcessings: 'Verfahren / Veredelungsmethode',
        tradeCountryPriceRanges: 'Preis',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* Sie haben bereits an OKAGESAMA teilgenommen',
        default: 'Standard',
        billingAddress: 'Rechnungsadresse',
        deliveryAddress: 'Lieferadresse',
        deliveryRequestFormRequestDate: 'Wunschliefertermin',
        fastestDeliveryRequest: 'Schnellstmöglicher Versand',
        deliveryRequestByDate: 'Zustellung nach Wunschtermin',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: 'Sonstige Provisionen *2',
        taxNodeForJpCalculation: '*1 zzgl. 8% Steuern / *2 zzgl. 10% Steuern / *3 nicht steuerpflichtig',
    },
    buttons: {
        yes: 'Ja ',
        no: 'Nein',
        create: 'Erstellen',
        update: 'Aktualisieren',
        delete: 'Löschen',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: 'Fertig',
        resetPassword: 'Passwort zurücksetzen',
        changePassword: 'Passwort ändern',
        reconfirmEmail: 'Bestätigungsmail noch einmal schicken',
        chooseFile: 'Wählen Sie eine Datei aus.',
        upload: 'Hochladen',
        calculateFixed: 'Endpreis festsetzen',
        cancelFixed: 'Endpreisfestsetzung abbrechen',
        pay: 'Als bezahlt markieren',
        unpay: 'Die bestätigte Bezahlung löschen',
        downloadInvoice: 'Rechnung herunterladen',
        salesContractDownloadPdf: 'Sales Contract herunterladen',
        auctionBonusInvoiceDownloadPdf: 'Auction Bonus Invoice herunterladen',
        downloadCsv: 'CSV herunterladen',
        deliveryRequest: 'Lieferung beauftragen',
        processing: 'In Bearbeitung',
        import: 'Import',
        addItem: 'Add Item',
        createContracts: 'Vertrag erstellen',
        changeStatusTo: 'Status ändern auf {{status}}',
        setBankAccount: 'Bankkonto auswählen',
        bankAccount: 'Bankkonto',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: 'Bezahlen',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: 'Reservierungsdetails anzeigen',
        setAsDefault: 'Als Standard festlegen',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: 'Weiter',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: 'Hier anmelden',
        register: 'Hier registrieren',
        resetPassword: 'Passwort vergessen? Hier',
        reconfirmEmail: 'Erneute Versendung der Bestätigungsmail hier',
        back: 'Zurück',
        payFromHere: 'Zur Kasse hier',
        story: 'Erzählung',
        movie: 'Film',
        privacy_policy: 'Datenschutzrichtlinie',
        specified_commercial_transactions_law: 'Allgemeine Geschäftsbedingungen',
        tos: 'Nutzungsbedingungen',
        trackingUrl: 'Stand des Transports',
        cookiePolicy: 'Cookie-Richtlinien',
    },
    messages: {
        registerSuccess: 'Um Korrektheit der Email-Adresse zu überprüfen, haben wir eine Mail an {{ email }} geschickt. Klicken Sie bitte auf den Link in der Email, um Ihre Registrierung abzuschließen.',
        confirmationSuccess: 'Die Email-Adresse wurde bestätigt. Bitte melden Sie sich mit der konfigurierten Mail-Adresse und dem Passwort an.',
        unlockSuccess: 'Das Konto ist freigeschaltet.',
        resetPasswordSuccess: 'Ein Zurücksetzen des Passwortes wurde beauftragt. Sie erhalten eine Email von uns.',
        accountUpdateSuccess: 'Eine Änderung der Information des Kundenkontos wurde beauftragt. Sie erhalten eine Email von uns.',
        changePasswordSuccess: 'Das Passwort wurde erfolgreich geändert.',
        reconfirmEmailSuccess: 'Erneute Versendung der Bestätigungsmail wurde angefordert. Sie bekommen eine Email von uns.',
        invalidEmail: 'Bitte geben Sie eine korrekte Email-Adresse ein',
        invalidPostalCode: 'Bitte geben Sie nur Zahlen für die Postleitzahl ein',
        loginSuccess: 'Erfolgreich angemeldet',
        logoutSuccess: 'Erfolgreich abgemeldet',
        uploadSuccess: 'Die hochgeladene CSV-Datei wurde geändert',
        createSuccess: 'Erfolgreich erstellt',
        updateSuccess: 'Erfolgreich aktualisiert',
        deleteSuccess: 'Erfolgreich gelöscht',
        updateFailure: 'Fehlgeschlagen',
        deleteConfirm: 'Möchten Sie das wirklich löschen?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: 'Das Gebot wird gelöscht. Möchten Sie wirklich fortfahren?',
        orderSuccess: 'Erfolgreich bestellt',
        typicaStockOrderSuccess: 'Bestellung abgeschlossen. Artikel, die bereits auf Lager sind, können über die Lagerbestandsliste zur Lieferung angefordert werden.',
        sampleOrderSuccess: 'Warenprobe erfolgreich reserviert',
        deliveryRequestSuccess: 'Die Lieferung wurde angefordert. Wir werden uns bei Ihnen erneut melden, sobald die Lieferung versandfertig wird.',
        cancelConfirm: 'Sie können eine Stornierung nicht rückgängig machen. Möchten Sie wirklich stornieren?',
        calculateFixed: "Hiermit wird die Reservierungsanfrage vom R\u00F6ster genehmigt und der Kaufvertrag abgeschlossen.\nVergewissern Sie sich, dass der Betrag stimmt. M\u00F6chten Sie den Endpreis festlegen?",
        calculateFixedSuccess: 'Der Endpreis für die betreffende Reservierung wurde festgelegt.',
        cancelFixed: "Hiermit wird der abgeschlossene Kaufvertrag mit dem R\u00F6ster widerrufen.\nEs entstehen Risiken beim Vertragswiderruf.\nM\u00F6chten Sie ihn wirklich widerrufen?",
        cancelFixedSuccess: 'Die Festlegung für den Endpreis wurde abgebrochen.',
        commentSuccess: 'Kommentiert',
        deleteCommentConfirmTitle: 'Kommentar löschen',
        deleteCommentConfirmBody: 'Möchten Sie den Kommentar wirklich löschen?',
        changePasswordTokenError: 'Die Gültigkeitsdauer zum Zurücksetzen des Passwortes ist abgelaufen. Bitte setzen Sie das Passwort erneut zurück.',
        deleteInvoiceConfirmTitle: 'Rechnung löschen',
        deleteInvoiceConfirmBody: 'Möchten Sie die Rechnung wirklich löschen?',
        deleteInvoiceItemConfirmTitle: 'Posten der Rechnung löschen',
        deleteInvoiceItemConfirmBody: 'Möchten Sie die Rechnungsposten wirklich löschen?',
        sendInvoiceMailConfirmTitle: 'Benachrichtgung per Email',
        sendInvoiceMailConfirmBody: 'Hiermit senden Sie eine Email, dass die Rechnung an den Röster erstellt wurde. Sind Sie sicher?',
        sentSuccess: 'Email wurde erfolgreich gesendet.',
        payConfirmTitle: 'Zahlungseingang als bestätigt markieren?',
        payConfirmBody: 'Zahlungseingang wird bestätigt. Sind Sie sicher?',
        unpayConfirmTitle: 'Zahlungseingangsbestätigung löschen',
        unpayConfirmBody: 'Möchten Sie den bestätigten Zahlungseingang wirklich löschen?',
        nRowsSelected: 'Sie haben {0} ausgewählt',
        noDeliveryRequest: 'Kein Lieferungsauftrag vorhanden',
        invalidOrderCombination: 'Anfrage und Reservierung der Warenprobe können nicht gleichzeitig durchgeführt werden.',
        orderExplanationTitle: 'Wichtige Informationen bezüglich der Reservierung',
        sampleOrderExplanationTitle: 'Zusätzliche Information zur Probenanfrage',
        auctionOrderExplanationTitle: 'Wichtige Informationen bezüglich Auktionsreservierungen',
        sampleOrderExplanationBody: "Probeanfragen sind aufgrund der begrenzten St\u00FCckzahl auf Kaufinteressenten beschr\u00E4nkt.\nWir veranstalten ebenfalls weltweit Verkostungen (Kaffee-Cupping), bei dem die Sorten aller Lose verkostet werden k\u00F6nnen.\nEinzelheiten entnehmen Sie bitte den Informationen per Email.",
        deliveryTimeExplanationTitle: 'Hinweise zum Versand',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* Die Kosten f\u00FCr den Inlandsversand werden gesondert berechnet.\n* Aufgrund von Unw\u00E4gbarkeiten beim Transport kann es zu Lieferverz\u00F6gerungen kommen.\n* Sollten Sie Fragen haben, k\u00F6nnen Sie sich gerne an uns wenden.\n* F\u00FCr die Lieferung aus dem niederl\u00E4ndischen Lager wird eine separate Geb\u00FChr erhoben.\n* Unser Lieferpartner CTS Group liefert die Waren zu Ihrer R\u00F6sterei.\n* Die Versandkosten entnehmen Sie bitte <0>folgender Datei</0>.\n* Pakete ab 23 kg werden gem\u00E4\u00DF der EU-Verordnung immer auf Palette geliefert.\n* Die Paletten sind nicht stapelbar, damit keine anderen Artikel auf den von Ihnen gekauften Kaffee gelegt werden. Demzufolge starten die Versandkosten bei 3/4 Europalette.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n* Pre-order pricing is ex-warehouse.\nThere are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\nPlease see <1>this file</1> for delivery costs by destination in NYC area.\nKindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n* An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n* The quality of the product shall be the same as the sample.\n\n* As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* Bitte \u00FCberpr\u00FCfen Sie in jedem Fall die <0>Nutzungsbedingungen</0>, bevor Sie eine Reservierung vornehmen.\n\n* F\u00FCr die Lieferung aus unserem Lager in den Niederlanden fallen zus\u00E4tzliche Geb\u00FChren an. Bitte entnehmen Sie Information zu den Versandkosten <1>hier</1>.\n\n* Je nach Herstellungsgebiet und Transportbedingungen kann es zu Verz\u00F6gerungen bei der Lieferung kommen.\n\n* Die Qualit\u00E4t des Produktes entspricht der Qualit\u00E4t der Warenprobe.\n\n* Die Herstellung von Rohkaffeebohnen wird stark von den Bedingungen des Herstellungsgebiets und des vorherrschenden Klimas beeinflusst, sodass sich die Bedingungen \u00E4ndern k\u00F6nnen. Eine Reservierung garantiert nicht, dass diese Reservierung abgeschlossen werden kann. Wir werden Sie nach Ablauf der Reservierungsfrist \u00FCber den Ausgang der Reservierung informieren.",
        createdInvoices: '{{count}} Rechnungen wurden erstellt.',
        orderNotStarted: 'Vorbestellung beginnt in {{ startedAt }}',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\n    Please make sure that you have not forgotten to create TYPICA Stock.\n    Do you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'Hinweise zum Herunterladen des Sales Contract',
        salesContractDownloadExplanationBody: "Bevor Sie den Sales Contract herunterladen k\u00F6nnen, m\u00FCssen Sie Ihr Bankkonto festlegen.\nBitte w\u00E4hlen Sie ein Bankkonto aus und f\u00FCgen Sie ggf. zus\u00E4tzliche Anmerkungen bei.",
        addBankAccountInformation: "Um den Sales Contract herunterladen zu k\u00F6nnen, m\u00FCssen Sie Ihr Bankkonto registrieren.\nBitte registrieren Sie Ihr Bankkonto \u00FCber den untenstehenden Link.",
        createBankAccount: 'Bankkontoinformationen registriert',
        orderedOfferNotExist: 'Noch kein Los reserviert',
        stripeConfirmBody: 'Bitte bestätigen Sie Ihre Zahlung',
        updateSuccessInvoicePaid: 'Die Zahlung ist abgeschlossen. Es kann einige Minuten dauern, bis die Rechnung zu »Zahlung abgeschlossen« wechselt. Bitte haben Sie noch etwas Geduld.',
        deliverySampleWarningMessage: 'Die Proben werden nach Wareneingang versandt. Der geplante Eingangstermin ist {{ approvalDate }}.',
        deliverySampleWarningConfirmationMessage: 'Die folgenden Proben werden nach Wareneingang versandt.',
        contactToTypicaMessage: 'Bitte verwenden Sie die folgende E-Mail-Adresse, um uns zu kontaktieren.',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: 'Wir sind ab dem 6. August 2024 auf die neue Plattform migriert. Wenn Sie sich als neuer Benutzer registrieren möchten, registrieren Sie sich bitte unter <0>Klicken Sie hier</0>.',
        newPlatformNotice: 'Wir werden ab dem 6. August 2024 auf die neue Plattform migrieren. Bitte verwenden Sie <0>hier</0>.',
        newPlatformSampleNotice: 'Eine Liste mit Beispielanfragen für die neue Plattform finden Sie <0>hier klicken</0>.',
        newPlatformOrderNotice: 'Die Reservierungsliste für die neue Plattform finden Sie <0>hier klicken</0>.',
        newPlatformInvoiceNotice: 'Die Rechnung für die neue Plattform lautet <0>Klicken Sie hier</0>.',
        newPlatformProfileNotice: "Hier aktualisierte Informationen werden nicht automatisch auf die neue Plattform \u00FCbertragen.\nWir entschuldigen uns f\u00FCr die Unannehmlichkeiten, aktualisieren aber bitte auch auf <0>Neue Plattform</0>.",
    },
    errors: {
        isRequired: 'Geben Sie {{ field }} ein',
        invalid: ' {{ field }} ist falsch',
        positive: 'Geben Sie bei {{ field }} mehr als 0 ein',
        integer: 'Geben Sie bei {{ field }} Zahlen ein',
        decimal: 'Geben Sie bei {{ field }} Zahlen mit Komma ein',
        alphanumeric: 'Geben Sie bei {{ field }} alphanumerische Zeichen ein',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: 'Dieses LOT ist nur bis zu {{limit}} zu reservieren',
        lowestBidFobPriceError: 'Der eingegebene Preis liegt unter dem Startpreis',
        totalFeeUpperLimitError: 'Sie haben Ihr Kreditkartenlimit überschritten. Bitte wechseln Sie zu Banküberweisung oder passen Sie Ihren Einkauf so an, dass der Gesamtbetrag unter 8-stellig ist.',
        noStock: 'Unzureichender Lagerbestand',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: 'Geben Sie als Gewicht der Losbestellung mindestens  {{ minOrder }} ein.',
        notSelectableLessThanOrdersTotalWeight120Kg: 'Auswählbar für Reservierungen ab 120 kg',
    },
    options: {
        isExists: {
            '1': 'Vorhanden',
            '0': 'Nicht vorhanden',
        },
        isQGrader: {
            '1': 'Ich besitze eine Q Grader-Qualifikation',
            '0': 'Ich besitze keine Q Grader-Qualifikation',
        },
    },
    stripePayment: {
        failure: 'Die Zahlung ist fehlgeschlagen. Bitte fangen Sie noch einmal von vorne an.',
        afterStatusSucceeded: 'Die Zahlung ist bereits erfolgt. Es kann einige Minuten dauern, bis der Zahlungsstatus zu »abgeschlossen« wechselt. Bitte haben Sie noch etwas Geduld.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
};
